export const LIST_MANAGEMENT_MODULE_ID = 'list-management-module';
export const LIST_MANAGEMENT_MODULE = () =>
  import('@capital-access/lists/components').then(m => m.ListManagementModule);
